// is this really better than normal case? Have to-remap in components for TS
export enum SearchMutations {
  RESET = "RESET",
  SET_VALUE = "SET_VALUE",
  SET_RESULTS = "SET_RESULTS",
}
